// removed by extract-text-webpack-plugin
module.exports = {"full-height":"_1N6ChTlLkKcTMVmU0D6kOi","row":"_28OqTfKR-dzEuR8GGMfG9s","title":"_t7DoICBqWyqsug76hpKd","custom-card-booking-review-right":"_2v6Q45E-uluorF9OQtI13y","ant-card":"f7YyX2inbIeTAH5iwmfVC","footer":"_1oxXC6YmqzhfOnVTxF2a6z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/Include/form_date_time.css
// module id = 3036
// module chunks = 0